import moment from 'moment';
import _ from 'lodash';
import { saveAs } from 'file-saver';

export class InvoiceUtils {

	static getPaymentStatusString(invoice: any) {
		if (invoice.amount <= 0) {
			return 'Hyvityslasku';
		} else if (InvoiceUtils.isPaid(invoice)) {
			return `Maksettu ${invoice.paidDate !== undefined ? InvoiceUtils.formatDate(invoice.paidDate) : ''}`;
		} else if (InvoiceUtils.isPaymentLate(invoice)) {
			return 'Lasku erääntynyt';
		} else if (InvoiceUtils.isPartlyPaid(invoice)) {
			return 'Maksettu osittain'
		}
		return 'Maksamatta';
	};

	static isPaid(invoice: any) {
		return (_.has(invoice, 'paidDate') && invoice.paidDate !== null) || (_.has(invoice, 'balance') && invoice.balance === 0);
	}

	static isPartlyPaid(invoice: any) {
		return (_.has(invoice, 'balance') && invoice.paidAmount > 0 && invoice.balance > 0 );
	}

	static isPaymentLate(invoice: any){
		const today = moment();
		const due = invoice && invoice.dueDate ? moment(invoice.dueDate) : null;
		if (!InvoiceUtils.isPaid(invoice)) {
			if (_.has(invoice, 'dueDate') && today.diff(due, 'days') > 1) {
				return true;
			}
		}
		return false;
	}

	static formatDate(dateString: string) {
		return moment(dateString).format('DD.MM.YYYY');
	}

	static saveAttachement(content: any, filename: string) {
		saveAs(content, filename);
	}
}